<template>
  <div class="renew-push">

  </div>
</template>
<script>
import { mapState } from 'vuex';
export default {
  name:'renewPush',
  data(){
    return {
      ws:null,
      notify:false,
    }
  },
  computed:{
    ...mapState(['LOGINUSER','TOKEN']),
  },
  watch:{
    TOKEN:{
      async handler(val){
        await this.$nextTick();
        this.ws && await this.ws.close();
        if(val){
          this.init();
        }
      },
      deep:true,
      immediate:true
    }
  },
  methods:{
    onPush(sim){
      const message = `
        <p>SN号：${sim.sn || ''}</p>
        <p>SIM卡号：${sim.simCard || ''}</p>
        <p>ICCID：${sim.iccid || ''}</p>
        <p>续费日期：${sim.renewDate || ''}</p>
        <p>到期日期：${sim.expireTime || ''}</p>
        <p>续费年限：${sim.years || ''}</p>
        <p>套餐类型：${sim.cardProductName || ''}</p>
      `
      this.notify = this.$notify({
        title: '续费提醒',
        duration:1000 * 5,
        type:'success',
        dangerouslyUseHTMLString:true,
        message,
        onClick:() => {
          this.$router.push('/renewManage/renewTable');
          this.notify.close();
        }
      });
    },
    init(){
      if(!['云杉','齐犇','ZF075'].includes(this.LOGINUSER.userCode)) return;
      this.ws = new WebSocket(`ws://sim.car900.com:18108/wss/sim/renewPush?sessionId=${this.TOKEN}`);
      this.ws.onopen = () => {
        console.log('weboskcet连接成功')
      };
      this.ws.onclose = async () => {
        console.log('weboskcet连接断开');
        // setTimeout(() => {
        //   init();
        // },3000);
      };
      this.ws.onmessage = (msg) => {
        if(msg.data){
          const data = JSON.parse(msg.data);
          this.onPush(data);
        }
        // this.onPush();
      };
    }
  },
}
</script>
<style lang="scss" scoped>

</style>